import React from 'react';
import image from 'assets/images/admin-forgot-password.png';
import { Col, Image, Modal, Row, Typography } from 'components';
import { ForgotPasswordForm } from 'components/auth';
import { CheckEmail } from '../modal/checkEmail';
import styles from '../signIn/styles.module.scss';
import { useForgotPassword } from './useForgotPassword';

const { Text } = Typography;

export const AdminForgotPassword = React.memo(() => {
  const { onFinish, onModalClose, isModalOpen, onModalOk, form, isLoading, contextHolder } = useForgotPassword();
  return (
    <Col>
      {contextHolder}
      <Row wrap={true} className={styles.signup} align={'middle'}>
        <Col lg={12} md={24}>
          <Row justify={'center'} className={styles.left_side}>
            <Col sm={15} xs={24} className={styles.form}>
              <Row gutter={[0, 24]}>
                <Col span={24}>
                  <Text className={styles.title}>Reset Password</Text>
                </Col>
                <Col span={24}>
                  <Text className={styles.description}>
                    Enter your email and we&apos;ll send you instructions to reset your password
                  </Text>
                </Col>
                <Col span={24}>
                  <ForgotPasswordForm
                    form={form}
                    onFinish={onFinish}
                    loading={isLoading}
                    submitButtonText="Request Reset Link"
                    showBackToLogin={false} // Admin layout doesn't need back to login link
                  />
                </Col>
              </Row>
            </Col>
          </Row>
        </Col>
        <Col lg={12} md={24}>
          <Row className={styles.right_side}>
            <Image src={image} alt={'image'} preview={false} width={'100%'} />
          </Row>
        </Col>
      </Row>
      <Modal closable={false} width={360} open={isModalOpen} footer={null} onCancel={onModalClose}>
        <CheckEmail onOk={onModalOk} />
      </Modal>
    </Col>
  );
});
